import * as React from 'react';
import DC from '../../common/DataConnector';
import { i18n } from '../../lang/i18n';
import BackArrow from '../../components/BackArrowComponent/BackArrow';
import Helpers from '../../common/Helpers';
import { actAlertShow, actLoading, actLoadingEnd } from '../../store/Actions';
import { useAppDispatch } from '../../store/hooks';


export default function RecommendFriends()
{
    const dispatch = useAppDispatch()
    const [friend, setFriend] = React.useState<any>({ name: '', email: '' });
    const [dataIsOk, setDataIdOk] = React.useState(false);
    const [friendResult, setFriendResult] = React.useState(-2);

    function onDataChange(data: any)
    {
        const f = { ...friend, ...data }
        setFriend(f)

        if (f.name.length < 4) {
            setDataIdOk(false)
            return;
        }
        if (f.email.length < 4 || !Helpers.FormValidateEmail(f.email)) {
            setDataIdOk(false)
            return;
        }
        setDataIdOk(true)
    }

    async function onSaveData()
    {
        actLoading(dispatch)
        const postData: any = {
            friendEmail: friend.email,
            friendName: friend.name
        }
        const result = await DC.PostData('/customer/recommend_friend', postData);
        if (result.wasOk) {
            setFriendResult(result.data)
        } else {
            actAlertShow(dispatch, "danger", i18n.Errors.ConnectionInfo, 3);
        }
        actLoadingEnd(dispatch)
    }

    function onInviteOther()
    {
        onDataChange({ name: '', email: '' })
        setFriendResult(-2)
    }

    function resultMessage()
    {
        switch (friendResult) {
            case 0:
                return i18n.RecommendFriends.InviteOk;
            case 1:
                return i18n.RecommendFriends.InviteCustomerActive;
            case 2:
                return i18n.RecommendFriends.InviteCustomerInvited;
        }
        return '';
    }

    return (
        <div className="users loyalty">
            <div className="main-subtitle">
                <h3>{i18n.RecommendFriends.Title1}</h3>
                <h5>{i18n.RecommendFriends.Title2}</h5>
            </div>
            <div className=''>
                <div>
                    <h5>{i18n.RecommendFriends.Steps}</h5>
                </div>
                <div className='mb-3'>
                    <div>{i18n.RecommendFriends.Step1}</div>
                    <div>{i18n.RecommendFriends.Step2}</div>
                    <div>{i18n.RecommendFriends.Step3}</div>
                </div>
                <div className='pt-3'>
                    <h5>{i18n.RecommendFriends.IMPORTANT}</h5>
                </div>
                <div className=''>
                    <div>{i18n.RecommendFriends.Important1}</div>
                    <div>{i18n.RecommendFriends.Important2}</div>
                    <div>{i18n.RecommendFriends.Important3}</div>
                </div>

                <div className='mt-5'>
                    <h3>{i18n.RecommendFriends.InviteYourFriend}</h3>
                </div>
                {friendResult === -2 && <div className='container p-3 block-form'>
                    <div className="form-group row">
                        <label className="col-4 col-form-label">{i18n.RecommendFriends.FriendName}</label>
                        <div className="col-8">
                            <input type="text" className="form-control" placeholder={i18n.RecommendFriends.FriendName}
                                onChange={(e: any) => { onDataChange({ name: e.target.value }); }}
                                value={friend.name} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-4 col-form-label">{i18n.RecommendFriends.FriendEmail}</label>
                        <div className="col-8">
                            <input type="email" className="form-control" placeholder={i18n.RecommendFriends.FriendEmail}
                                onChange={(e: any) => { onDataChange({ email: e.target.value }); }}
                                value={friend.email} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">*{i18n.RecommendFriends.FriendRequirements}</label>
                    </div>
                    <div className='text-center'>
                        <button className='btn btn-warning btn-main' onClick={onSaveData} disabled={!dataIsOk} >{i18n.RecommendFriends.BNTInvite}</button>
                    </div>
                </div>}
                {friendResult !== -2 && <div className='container p-3 block-form'>
                    <div className="form-group row">
                        <label className="col-12 col-form-label">{resultMessage()}</label>
                    </div>
                    <div className='text-center'>
                        <button className='btn btn-warning btn-main' onClick={onInviteOther} disabled={!dataIsOk} >{i18n.RecommendFriends.BNTInviteOther}</button>
                    </div>
                </div>}
            </div>
            <BackArrow path="/user" />
        </div>
    );
}